"use client"

import React from 'react'
import { useTranslations } from 'next-intl'
import { UIInput, type UIInputProps } from './ui-input'
import { cn } from '../../lib/utils'

export interface UIInputDefaultProps extends Omit<UIInputProps, 'type' | 'placeholder'> {
  type?: 'email' | 'text' | 'password'
  placeholder?: string
}

/**
 * UIInputDefault - Default Input Block
 * 기본 이메일 입력 필드 컴포넌트입니다.
 * 기본적인 이메일 입력 필드입니다.
 */
export const UIInputDefault = React.forwardRef<HTMLInputElement, UIInputDefaultProps>(
  ({
    type = "email",
    placeholder,
    className,
    ...props
  }, ref) => {
    const t = useTranslations('components.forms')

    return (
      <UIInput
        ref={ref}
        type={type}
        placeholder={placeholder || t('input.email.placeholder')}
        className={cn("max-w-xs", className)}
        {...props}
      />
    )
  }
)

UIInputDefault.displayName = "UIInputDefault"